export const generic = "cheerz_CartPaymentForm_generic";
const expiredCard = "cheerz_CartPaymentForm_card_expired";
const invalidCard = "cheerz_CartPaymentForm_card_invalid";
const refusedPayment = "cheerz_CartPaymentForm_payment_refused";
const invalidNumber = "cheerz_CartPaymentForm_cb_number_invalid";
const invalidMonth = "cheerz_CartPaymentForm_cb_month_invalid";
const invalidYear = "cheerz_CartPaymentForm_cb_year_invalid";
const invalidCvc = "cheerz_CartPaymentForm_cb_cvc_invalid";

interface ErrorMessages {
  [key: string]: string;
}

export const errorMessages: ErrorMessages = {
  "card.acquirer-failed": generic,
  "card.bad-track-data": invalidCard,
  "card.blacklisted": generic,
  "card.contact-bank": refusedPayment,
  "card.currency-unsupported": generic,
  "card.declined": generic,
  "card.do-not-honor": generic,
  "card.dont-retry": generic,
  "card.duplicate": generic,
  "card.exceeded-activity-limits": refusedPayment,
  "card.exceeded-limits": refusedPayment,
  "card.exceeded-withdrawal-limit": refusedPayment,
  "card.expired": expiredCard,
  "card.expired-3ds": generic,
  "card.failed-3ds": generic,
  "card.failed-avs": generic,
  "card.failed-avs-address": generic,
  "card.failed-avs-postal": generic,
  "card.failed-cvc": invalidCvc,
  "card.failed-cvc-and-avs": generic,
  "card.invalid": invalidCard,
  "card.invalid-account": refusedPayment,
  "card.invalid-address": generic,
  "card.invalid-cvc": invalidCvc,
  "card.invalid-expiry-date": invalidCard,
  "card.invalid-month": invalidMonth,
  "card.invalid-name": invalidCard,
  "card.invalid-number": invalidNumber,
  "card.invalid-pin": invalidCard,
  "card.invalid-year": invalidYear,
  "card.invalid-zip": generic,
  "card.issuer-down": generic,
  "card.issuer-failed": generic,
  "card.issuer-not-found": generic,
  "card.lost": generic,
  "card.maximum-attempts": refusedPayment,
  "card.missing-3ds": generic,
  "card.missing-cvc": invalidCvc,
  "card.missing-expiry": invalidCard,
  "card.missing-number": invalidNumber,
  "card.needs-authentication": generic,
  "card.network-failed": generic,
  "card.no-action-taken": generic,
  "card.no-money": refusedPayment,
  "card.not-activated": generic,
  "card.not-authorized": generic,
  "card.not-registered": generic,
  "card.not-supported": generic,
  "card.please-retry": generic,
  "card.possible-fraud": generic,
  "card.processing-error": generic,
  "card.revoked": generic,
  "card.revoked-all": generic,
  "card.security-violation": generic,
  "card.stolen": generic,
  "card.test": generic,
  "card.type-not-supported": generic,
  "card.unsupported-3ds": generic,
  "customer.cancelled": generic,
  "gateway.declined": generic,
  "gateway.not-allowed": generic,
  "gateway.validation-error": generic,
  "payment.declined": generic,
};
